module Meevo.Plugins.WorkActivities {
  "use strict";

  /**
  * Main Section of Work Activities 
  */
    export class MainSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.WorkActivity> {
        private _isHolidayOrSickTime: boolean;

        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Components.Logging.ILoggingService,
            dataService: Components.BaseClasses.IDataService,
            protected identityService: Components.Common.IIdentityService = null,
            noun: Model.NounEnum = null,
            private modalService: Meevo.Components.Modal.IModalService,
            sectionSecurityKey?: string) {

            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, identityService, noun, null, sectionSecurityKey);
            
        }

        /**
        * Base class override which defines what a DEFAULT model looks like.
        */
        createSectionModelInstance(postAdd: (data: any) => any): void {
            this.dataService.getTemplate(this.baseEndpoint).then((data) => {
                this.model = data;
            });
        }

        public workActivityCategoryChanged(): void {
            const isHolidayOrSickTime = this.model.category === Model.WorkActivityCategoryEnum.Holiday || this.model.category === Model.WorkActivityCategoryEnum.SickTime || this.model.category === Model.WorkActivityCategoryEnum.Vacation;
            if (isHolidayOrSickTime) {
                this.modalService.confirmHandler('LABEL_WORK_ACTIVITY_CATEGORY_UPDATE_WARNING', Components.Modal.ModalTranslationModes.Translate)
                    .then((res) => {
                        if (!!res) {
                            this.model.isBookableTime = false;
                            this.model.shouldIncludeInProductivity = false;
                            this.model.mustPunchIn = false;
                            this.model.serviceCategories = [];
                        } else {
                            this.model.category = Model.WorkActivityCategoryEnum.None;
                        }
                    })
            }
            this.isHolidayOrSickTime = isHolidayOrSickTime;
        }

        public sectionModelRetrieved(): void {
            if (Model.Guard.isSomething(this.model))
            {
                const isHolidayOrSickTime = this.model.category === Model.WorkActivityCategoryEnum.Holiday || this.model.category === Model.WorkActivityCategoryEnum.SickTime || this.model.category === Model.WorkActivityCategoryEnum.Vacation;
                this.isHolidayOrSickTime = isHolidayOrSickTime
            }
        }

        get isHolidayOrSickTime() {
            return this._isHolidayOrSickTime;
        }

        set isHolidayOrSickTime(value: boolean) {
            this._isHolidayOrSickTime = value;
        }

    }
}